import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule , FormsModule } from '@angular/forms';

// Angular AG Grid
import { AgGridModule } from 'ag-grid-angular';
// Material
import { MatNativeDateModule } from '@angular/material/core';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
// custom components
import { AutoCompleteFilterComponent } from './datagrid/datagrid.FilterAutoComplete';
import { DgFilterComponent } from './datagrid/datagrid.Filter';
import { TextFilterComponent } from './datagrid/datagrid.FilterText';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { RadioComponent } from './radio/radio.component';
import { FileComponent } from './file/file.component';
import { ImgComponent } from './img/img.component';
import { AutocompleteComponent } from './autocomplete/autocomplete.component';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { DatecomboComponent } from './datecombo/datecombo.component';
import { ButtonComponent } from './button/button.component';
import { InputComponent } from './input/input.component';
import { PageViewerComponent } from './page-viewer/page-viewer.component';
import { PageViewerSafeUrlPipe } from './page-viewer/page-viewer-safe-url.pipe';
import { FormComponent } from './form/form.component';
import { FormItemDirective } from './form/form-item.directive';
import { ButtonbarComponent } from './buttonbar/buttonbar.component';
import { DatagridComponent } from './datagrid/datagrid.component';
import { PageComponent } from './page/page.component';
import { DefaultMasterDetailPageComponent } from './default-master-detail-page/default-master-detail-page.component';
import { DefaultListPageComponent } from './default-list-page/default-list-page.component';
import { DefaultEditPageComponent } from './default-edit-page/default-edit-page.component';
import { OnlyNumericDirective } from './directives/only-numeric.directive';
import { NumericFilterComponent } from './datagrid/datagrid.FilterNumeric';
import { DateFilterComponent } from './datagrid/datagrid.FilterDate';
import { DropDownFilterComponent } from './datagrid/datagrid.FilterDropdown';
import { TranslateModule } from '@ngx-translate/core';
import { ActionsSideToolBarComponent } from './datagrid/datagrid.ActionsSideToolBar';
import { EditorAutoCompleteComponent } from './datagrid/datagrid.EditorAutoComplete';
import { EditorDecimalNumericComponent } from './datagrid/datagrid.EditorDecimalNumeric';
import { TableComponent } from './table/table.component';
import { DefaultDialogPageComponent } from './default-dialog-page/default-dialog-page.component';
import { MatButtonModule } from '@angular/material/button';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { EditDialogComponent } from './edit-dialog/edit-dialog.component';
import { ApprovalProcessesDialogComponent } from './approval-processes-dialog/approval-processes-dialog.component';
import { DefaultReportPageComponent } from './default-report-page/default-report-page.component';
import { ProgressSpinnerComponent } from './progress-spinner/progress-spinner.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { InfoCardComponent } from './info-card/info-card.component';

@NgModule({
  declarations: [
    DatagridComponent,
    AutoCompleteFilterComponent,
    DropDownFilterComponent,
    EditorAutoCompleteComponent,
    ActionsSideToolBarComponent,
    EditorDecimalNumericComponent,
    DgFilterComponent,
    TextFilterComponent,
    DateFilterComponent,
    NumericFilterComponent,
    CheckboxComponent,
    DropdownComponent,
    RadioComponent,
    FileComponent,
    ImgComponent,
    AutocompleteComponent,
    DatepickerComponent,
    DatecomboComponent,
    ButtonComponent,
    InputComponent,
    PageViewerComponent,
    PageViewerSafeUrlPipe,
    FormComponent,
    FormItemDirective,
    ButtonbarComponent,
    PageComponent,
    DefaultMasterDetailPageComponent,
    DefaultListPageComponent,
    DefaultEditPageComponent,
    OnlyNumericDirective,
    TableComponent,
    DefaultDialogPageComponent,
    ConfirmationDialogComponent,
    EditDialogComponent,
    ApprovalProcessesDialogComponent,
    DefaultReportPageComponent,
    ProgressSpinnerComponent,
    BreadcrumbComponent,
    InfoCardComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    AgGridModule.withComponents([
      AutoCompleteFilterComponent,
      DropDownFilterComponent,
      DgFilterComponent,
      TextFilterComponent,
      NumericFilterComponent,
      DateFilterComponent,
      EditorAutoCompleteComponent,
      ActionsSideToolBarComponent,
      EditorDecimalNumericComponent
    ]),
    ReactiveFormsModule,
    FormsModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatPaginatorModule,
    MatSelectModule,
    MatCheckboxModule,
    MatRadioModule,
    MatTabsModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatProgressSpinnerModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    MatIconModule,
    MatSnackBarModule,
    MatGridListModule,
    MatButtonModule
  ],
  entryComponents: [
    CheckboxComponent,
    DropdownComponent,
    RadioComponent,
    FileComponent,
    ImgComponent,
    AutocompleteComponent,
    DatepickerComponent,
    DatecomboComponent,
    ButtonComponent,
    InputComponent,
    PageViewerComponent,
    ButtonbarComponent,
    TableComponent
  ],
  exports: [
    DatagridComponent,
    CheckboxComponent,
    DropdownComponent,
    RadioComponent,
    FileComponent,
    ImgComponent,
    AutocompleteComponent,
    DatepickerComponent,
    DatecomboComponent,
    ButtonComponent,
    InputComponent,
    PageViewerComponent,
    PageViewerSafeUrlPipe,
    FormComponent,
    ButtonbarComponent,
    PageComponent,
    DefaultMasterDetailPageComponent,
    DefaultListPageComponent,
    DefaultEditPageComponent,
    DefaultReportPageComponent,
    ProgressSpinnerComponent,
    TableComponent,
    ConfirmationDialogComponent,
    EditDialogComponent,
    ApprovalProcessesDialogComponent,
    BreadcrumbComponent,
	InfoCardComponent
  ],
})
export class ComponentsModule { }
